import React, { useState } from "react";
import "./NavBar.css";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import TextAnimation from "react-text-animations";


function NavBar() {



  const [activeStatus, setactiveStatus] = useState("home");
  const [toggle, settoggle] = useState(true);
  const [drop, setdrop] = useState(true)
  const [drops, setdrops] = useState(true)


  return (
    <div>
      <nav class="navbar navbar-div1 navbar-expand-lg navbar-light ">
        <Link
          class="navbar-brand portfolio-logo "
          to="/"
          onClick={() => { setactiveStatus("home"); setdrop(true); setdrops(true) }}
        > 
          <TextAnimation.Slide target="QASIM" text={['QASIM', 'DESIGNER']} animation={{
        duration:1000,
        delay:2000,
        timingFunction:'ease-out',
    }}>
            IAM QASIM 
        </TextAnimation.Slide>

        </Link>

        <button
          class="navbar-toggler "
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <div
          class="collapse navbar-collapse"
          id="navbarSupportedContent"
        >
          <ul class="navbar-nav navbar-ul">
            <li
              className={`${activeStatus === "home"
                ? "nav-item active nav-li1"
                : "nav-item nav-li1"
                }`}
            >

              <HashLink
                class="nav-link"
                to="/#home"
                spy={true}
                smooth={true}
                offset={-100}
                duration={600}
                onClick={() => { setactiveStatus("home"); setdrop(true); setdrops(true) }}
              >
                Home
              </HashLink>
            </li>
            <li
              className={`${activeStatus === "about"
                ? "nav-item active nav-li1"
                : "nav-item nav-li1"
                }`}
            >
              <HashLink
                class="nav-link"
                to="/#about-me"
                spy={true}
                smooth={true}
                offset={-100}
                duration={600}
                onClick={() => { setactiveStatus("home"); setdrop(true); setdrops(true) }}
              >
                About
              </HashLink>
            </li>

            <li
              className={`${activeStatus === "portfolio"
                ? "nav-item active nav-li1"
                : "nav-item nav-li1"
                }`}
            >
              <Link
                class="nav-link"
                to="/portfolio"
                onClick={() => { setactiveStatus("portfolio"); setdrop(true); setdrops(true) }}
              >
                Portfolio
              </Link>
            </li>

            <li className={`${activeStatus === "figmafolio"
              ? "nav-item active nav-li1 dropdown"
              : "nav-item nav-li1 dropdown"
              }`}>
              <a class="nav-link dropdown-toggle" href="#" role="button" aria-expanded="false" onClick={() => { setactiveStatus("figmafolio"); setdrop(!drop); setdrops(true) }}>
                Figma Folio
              </a>
              <div class={`${drop === true ? "dropdown-menu dropdown-menu-div" : "dropdown-menu dropdown-menu-div show"}`}>
                <div className="dropdown-item-div1">
                  <a href="https://www.figma.com/file/ZtxXHtoGYEE5KysqrUmblp/Web-UI-UX" target='_blank' class="dropdown-item dropdown-item-text" ><svg className="mr-3" width="20" height="6" viewBox="0 0 20 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19.2475 3.24749C19.3842 3.1108 19.3842 2.8892 19.2475 2.75251L17.0201 0.525126C16.8834 0.388443 16.6618 0.388443 16.5251 0.525126C16.3884 0.66181 16.3884 0.883418 16.5251 1.0201L18.505 3L16.5251 4.9799C16.3884 5.11658 16.3884 5.33819 16.5251 5.47487C16.6618 5.61156 16.8834 5.61156 17.0201 5.47487L19.2475 3.24749ZM0 3.35H19V2.65H0V3.35Z" fill="white" />
                  </svg>
                    Web UI/UX</a>
                </div>
                <div class="dropdown-divider mx-auto"></div>
                <div className="dropdown-item-div1">
                  <a class="dropdown-item dropdown-item-text" href="https://www.figma.com/file/dRd1xglL5pPSzEahkEMKlW/Mobile-UI-UX" target="_blank"> <svg className="mr-3" width="20" height="6" viewBox="0 0 20 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19.2475 3.24749C19.3842 3.1108 19.3842 2.8892 19.2475 2.75251L17.0201 0.525126C16.8834 0.388443 16.6618 0.388443 16.5251 0.525126C16.3884 0.66181 16.3884 0.883418 16.5251 1.0201L18.505 3L16.5251 4.9799C16.3884 5.11658 16.3884 5.33819 16.5251 5.47487C16.6618 5.61156 16.8834 5.61156 17.0201 5.47487L19.2475 3.24749ZM0 3.35H19V2.65H0V3.35Z" fill="white" />
                  </svg>
                    Mobile UI/UX</a>
                </div>
              </div>
            </li>

            <li className={`${activeStatus === "contact"
              ? "nav-item active nav-li1 dropdown"
              : "nav-item nav-li1 dropdown"
              }`}>
              <a class="nav-link dropdown-toggle" href="#" role="button" aria-expanded="false" onClick={() => { setactiveStatus("contact"); setdrop(true); setdrops(!drops) }}>
                Contact
              </a>
              <div class={`${drops === true ? "dropdown-menu dropdown-menu-div1" : "dropdown-menu dropdown-menu-div1 show"}`}>
                <div className="dropdown-item-div1">
                  <a class="dropdown-item dropdown-item-text" href="tel:+923135596055"><svg className="mr-3" width="20" height="6" viewBox="0 0 20 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19.2475 3.24749C19.3842 3.1108 19.3842 2.8892 19.2475 2.75251L17.0201 0.525126C16.8834 0.388443 16.6618 0.388443 16.5251 0.525126C16.3884 0.66181 16.3884 0.883418 16.5251 1.0201L18.505 3L16.5251 4.9799C16.3884 5.11658 16.3884 5.33819 16.5251 5.47487C16.6618 5.61156 16.8834 5.61156 17.0201 5.47487L19.2475 3.24749ZM0 3.35H19V2.65H0V3.35Z" fill="white" />
                  </svg>
                    Call Me</a>
                </div>
                <div class="dropdown-divider mx-auto"></div>
                <div className="dropdown-item-div1">
                  <a class="dropdown-item dropdown-item-text" href="mailto:hi@imqasim.com"><svg className="mr-3" width="20" height="6" viewBox="0 0 20 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19.2475 3.24749C19.3842 3.1108 19.3842 2.8892 19.2475 2.75251L17.0201 0.525126C16.8834 0.388443 16.6618 0.388443 16.5251 0.525126C16.3884 0.66181 16.3884 0.883418 16.5251 1.0201L18.505 3L16.5251 4.9799C16.3884 5.11658 16.3884 5.33819 16.5251 5.47487C16.6618 5.61156 16.8834 5.61156 17.0201 5.47487L19.2475 3.24749ZM0 3.35H19V2.65H0V3.35Z" fill="white" />
                  </svg>
                    Email Me</a>
                </div>
                <div class="dropdown-divider mx-auto "></div>
                <div className="dropdown-item-div2">
                  <a class="dropdown-item dropdown-item-text1" href="/bookameeting">
                    Book a Meeting </a>
                </div>


              </div>
            </li>
          </ul>
        </div>
      </nav>







      <nav class="navbar mobile-navbar-div1 d-flex d-lg-none navbar-expand-lg navbar-light ">
        <Link
          class="navbar-brand mobile-portfolio-logo  "
          to="/#home"
          onClick={() => { setactiveStatus("home"); setdrop(true); setdrops(true) }}
        >
          <TextAnimation.Slide target="QASIM" text={['QASIM', 'DESIGNER']} animation={{
            duration: 1000,
            delay: 2000,
            timingFunction: 'ease-out',
          }}>
            IAM  QASIM
          </TextAnimation.Slide>
        </Link>
        <button
          class="navbar-toggler mr-sm-4 mr-2"
          type="button"
          // data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
          onClick={() => { settoggle(!toggle); setdrop(true); setdrops(true) }}
        >
          <svg width="39" height="22" viewBox="0 0 39 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1H37.5" stroke="white" stroke-width="2" stroke-linecap="round" />
            <path d="M11.5 11L37.5 11" stroke="white" stroke-width="2" stroke-linecap="round" />
            <path d="M19.5 21L37.5 21" stroke="white" stroke-width="2" stroke-linecap="round" />
          </svg>

        </button>


        <div
          class={`${toggle
            ? "navbar-collapse mobile-navbar-div2"
            : "navbar-collapse mobile-navbar-div2 show"
            } `}
          id="navbarSupportedContent"
        >
          <ul class="navbar-nav mx-auto">
            <li
              className={`${activeStatus === "home"
                ? "nav-item mobile-nav-item active home1"
                : "nav-item mobile-nav-item home1"
                }`}
            >
              <HashLink
                class="nav-link"
                to="/#home"
                spy={true}
                smooth={true}
                offset={-100}
                duration={600}
                onClick={() => { setactiveStatus("home"); settoggle(!toggle); setdrop(true); setdrops(true) }}
              >
                Home
              </HashLink>
            </li>
            <li
              className={`${activeStatus === "about"
                ? "nav-item mobile-nav-item active home1"
                : "nav-item mobile-nav-item home1"
                }`}
            >
              <HashLink
                class="nav-link"
                to="/#about-me"
                spy={true}
                smooth={true}
                offset={-100}
                duration={600}
                onClick={() => { setactiveStatus("home"); settoggle(!toggle); setdrop(true); setdrops(true) }}
              >
                About Us
              </HashLink>
            </li>

            <li
              className={`${activeStatus === "portfolio"
                ? "nav-item mobile-nav-item active home1"
                : "nav-item mobile-nav-item home1"
                }`}
            >
              <HashLink
                class="nav-link"
                to="/portfolio"
                spy={true}
                smooth={true}
                offset={-100}
                duration={600}
                onClick={() => { setactiveStatus("portfolio"); settoggle(!toggle); setdrop(true); setdrops(true) }}
              >
                Portfolio
              </HashLink>
            </li>


            <li className={`${activeStatus === "figmafolio"
              ? "nav-item mobile-nav-item active home1 dropdown"
              : "nav-item mobile-nav-item home1 dropdown"
              }`}>
              <a class="nav-link dropdown-toggle" href="#" role="button" aria-expanded="false" onClick={() => { setactiveStatus("figmafolio"); setdrop(!drop); setdrops(true) }}>
                Figma Folio
              </a>
              <div class={`${drop === true ? "dropdown-menu dropdown-menu-div" : "dropdown-menu dropdown-menu-div show"}`}>
                <div className="dropdown-item-div1">
                  <a href="https://www.figma.com/file/ZtxXHtoGYEE5KysqrUmblp/Web-UI-UX" target="_blank" class="dropdown-item dropdown-item-text" ><svg className="mr-3" width="20" height="6" viewBox="0 0 20 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19.2475 3.24749C19.3842 3.1108 19.3842 2.8892 19.2475 2.75251L17.0201 0.525126C16.8834 0.388443 16.6618 0.388443 16.5251 0.525126C16.3884 0.66181 16.3884 0.883418 16.5251 1.0201L18.505 3L16.5251 4.9799C16.3884 5.11658 16.3884 5.33819 16.5251 5.47487C16.6618 5.61156 16.8834 5.61156 17.0201 5.47487L19.2475 3.24749ZM0 3.35H19V2.65H0V3.35Z" fill="white" />
                  </svg>
                    Web UI/UX</a>
                </div>
                <div class="dropdown-divider mx-auto"></div>
                <div className="dropdown-item-div1">
                  <a class="dropdown-item dropdown-item-text" href="https://www.figma.com/file/dRd1xglL5pPSzEahkEMKlW/Mobile-UI-UX" target="_blank"> <svg className="mr-3" width="20" height="6" viewBox="0 0 20 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19.2475 3.24749C19.3842 3.1108 19.3842 2.8892 19.2475 2.75251L17.0201 0.525126C16.8834 0.388443 16.6618 0.388443 16.5251 0.525126C16.3884 0.66181 16.3884 0.883418 16.5251 1.0201L18.505 3L16.5251 4.9799C16.3884 5.11658 16.3884 5.33819 16.5251 5.47487C16.6618 5.61156 16.8834 5.61156 17.0201 5.47487L19.2475 3.24749ZM0 3.35H19V2.65H0V3.35Z" fill="white" />
                  </svg>
                    Mobile UI/UX</a>
                </div>
              </div>
            </li>



            <li className={`${activeStatus === "contact"
              ? "nav-item mobile-nav-item active home1 dropdown"
              : "nav-item mobile-nav-item home1 dropdown"
              }`}>
              <a class="nav-link dropdown-toggle" href="#" role="button" aria-expanded="false" onClick={() => { setactiveStatus("contact"); setdrop(true); setdrops(!drops) }}>
                Contact
              </a>
              <div class={`${drops === true ? "dropdown-menu dropdown-menu-div1" : "dropdown-menu dropdown-menu-div1 show"}`}>
                <div className="dropdown-item-div1">
                  <a class="dropdown-item dropdown-item-text" href="tel:+923135596055"><svg className="mr-3" width="20" height="6" viewBox="0 0 20 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19.2475 3.24749C19.3842 3.1108 19.3842 2.8892 19.2475 2.75251L17.0201 0.525126C16.8834 0.388443 16.6618 0.388443 16.5251 0.525126C16.3884 0.66181 16.3884 0.883418 16.5251 1.0201L18.505 3L16.5251 4.9799C16.3884 5.11658 16.3884 5.33819 16.5251 5.47487C16.6618 5.61156 16.8834 5.61156 17.0201 5.47487L19.2475 3.24749ZM0 3.35H19V2.65H0V3.35Z" fill="white" />
                  </svg>
                    Call Me</a>
                </div>
                <div class="dropdown-divider mx-auto"></div>
                <div className="dropdown-item-div1">
                  <a class="dropdown-item dropdown-item-text" href="mailto:hi@imqasim.com"><svg className="mr-3" width="20" height="6" viewBox="0 0 20 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19.2475 3.24749C19.3842 3.1108 19.3842 2.8892 19.2475 2.75251L17.0201 0.525126C16.8834 0.388443 16.6618 0.388443 16.5251 0.525126C16.3884 0.66181 16.3884 0.883418 16.5251 1.0201L18.505 3L16.5251 4.9799C16.3884 5.11658 16.3884 5.33819 16.5251 5.47487C16.6618 5.61156 16.8834 5.61156 17.0201 5.47487L19.2475 3.24749ZM0 3.35H19V2.65H0V3.35Z" fill="white" />
                  </svg>
                    Email Me</a>
                </div>
                <div class="dropdown-divider mx-auto "></div>
                <div className="dropdown-item-div2">
                  <a class="dropdown-item dropdown-item-text1" href="/bookameeting" >
                    Book a Meeting </a>
                </div>


              </div>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  );
}

export default NavBar;
